import { ProductListViewContext, ProductListViewContextProvider } from "./ProductListView";
import ProductList from "./views/ProductList";

export const ProductListPage = () => {
  return (
    <ProductListViewContextProvider>
      <ProductList />
    </ProductListViewContextProvider>
  );
};
